import moment from 'moment';
import _ from 'lodash';
import { paywayLinealChannels } from 'services/api/payway/linealChannels';
import { getEpgChannel } from 'services/api/epg/channel';
import RequestManager from 'requests/RequestManager';
import RecordingsDataTask from 'requests/tasks/recordings/RecordingsDataTask';
import RecordingsAddTask from 'requests/tasks/recordings/RecordingsAddTask';
import RecordingsDeleteTask from 'requests/tasks/recordings/RecordingsDeleteTask';
import * as type from './util/constants';
import { notAllowed } from './util/utils';
import {
  GetNodeId,
  GetEpgVersion,
  tvEverywhereEnable,
} from '../../utils/getEpgParams';

export const EVENT_CARD_IS_LOADING_PAGE = 'EVENT_CARD_IS_LOADING_PAGE';
export const EVENT_CARD_SET_EPG_CHANNELS = 'EVENT_CARD_SET_EPG_CHANNELS';
export const EVENT_CARD_SET_CONTENT_DATA = 'EVENT_CARD_SET_CONTENT_DATA';
export const EVENT_CARD_SET_LINEAL_CHANNELS = 'EVENT_CARD_SET_LINEAL_CHANNELS';
export const EVENT_CARD_RECORDINGS_DATA = 'EVENT_CARD_RECORDINGS_DATA';

export const setEvent = (event = {}) => ({
  type: EVENT_CARD_SET_EPG_CHANNELS,
  event,
});
export const setContentData = (contentData = {}) => ({
  type: EVENT_CARD_SET_CONTENT_DATA,
  contentData,
});

export const setLinealChannels = (channel = {}) => ({
  type: EVENT_CARD_SET_LINEAL_CHANNELS,
  channel,
});

export const setRecordingData = (recordings_data = {}) => ({
  type: EVENT_CARD_RECORDINGS_DATA,
  recordings_data,
});

export const setIsLoadingPage = (isLoadingPage = true) => ({
  type: EVENT_CARD_IS_LOADING_PAGE,
  isLoadingPage,
});

export const fetchEvent = (
  config,
  timeShift,
  eventId,
  startTime,
  groupId,
) => dispatch => {
  const timeShiftHours = timeShift > 0 ? timeShift / 2 : 12;
  const st = parseInt(startTime, 10);
  let now = moment();
  if (!isNaN(st)) {
    now = moment(st);
  }
  const dateFrom = now
    .clone()
    .subtract(timeShiftHours, type.EVENT_MANIPULATE_KEY_EPG)
    .format(type.EVENT_CARD_FORMAT_TIME_EPG);

  const dateTo = now
    .clone()
    .add(timeShiftHours, type.EVENT_MANIPULATE_KEY_EPG)
    .format(type.EVENT_CARD_FORMAT_TIME_EPG);

  const params = {
    date_from: dateFrom,
    date_to: dateTo,
    quantity: '200',
    node_id: GetNodeId(),
  };
  if (GetEpgVersion() && tvEverywhereEnable()) {
    params.epg_version = GetEpgVersion();
  }
  getEpgChannel(params)
    .then(data => {
      const eventData = data.response.channels
        .filter(c => c.group_id === groupId)
        .reduce(
          (pc, c) =>
            pc ||
            c.events.reduce((p, event) => {
              if (event.id === eventId) {
                return { e: event, contentData: c.group.common };
              }
              return p;
            }, undefined),
          undefined,
        );

      const { e, contentData } = eventData || {};
      contentData.timeshift = +contentData.timeshift || 0;
      if (typeof e !== 'undefined') {
        dispatch(setEvent(e));
        dispatch(setContentData(contentData));
        dispatch(setIsLoadingPage(false));
      } else {
        dispatch(setIsLoadingPage(false));
        throw Error(type.EVENT_CARD_ERROR_EVENT_NOT_FOUND);
      }
    })
    .catch(err => {
      console.error(type.EVENT_CARD_ERROR_REQUEST, err);
      notAllowed();
    });
};

export const fetchLinealChannels = groupId => async dispatch => {
  dispatch(setIsLoadingPage(true));
  const result = await paywayLinealChannels();
  const status = _.get(result, 'status', '1');

  if (status !== '0')
    return console.error(type.EVENT_CARD_ERROR_REQUEST, result.errors);

  const paq = _.get(result, 'response.paqs.paq', []);
  let currentChannel = {};
  _.map(paq, o => {
    if (o.groups.indexOf(groupId) !== -1) {
      if (Number.parseInt(o.timeshift, 10) > 0) {
        currentChannel = o;
        currentChannel.timeshift = Number.parseInt(o.timeshift, 10);
      }
      if (Number.parseInt(o.npvrstorage, 10) > 0) {
        currentChannel.payway_token_npvr = o.payway_token;
        currentChannel.npvrstorage = Number.parseInt(o.npvrstorage, 10);
      }
    }
  });

  if (!_.isEmpty(currentChannel)) {
    dispatch(setLinealChannels(currentChannel));
  } else {
    dispatch(
      setLinealChannels({
        npvrstorage: 0,
        payway_token: 0,
        play: 0,
      }),
    );
  }
  return dispatch(setIsLoadingPage(false));
};

export const recordingData = (config, data) => dispatch => {
  const dataRequest = new RecordingsDataTask(config, data);
  RequestManager.addRequest(dataRequest)
    .then(data => {
      if (data.response.length == 0 || data.response.status == undefined) {
        dispatch(setRecordingData({ status: 'ERROR' }));
      } else {
        dispatch(
          setRecordingData({
            ...data.response,
            isRecordingData: true,
          }),
        );
      }
    })
    .catch(e => {
      dispatch(setRecordingData({ status: 'ERROR' }));
      console.log('EVENT_CARD_ERROR_REQUEST');
    });
};

export const recordingAdd = (config, data) => dispatch => {
  const dataRequest = new RecordingsAddTask(config, data);
  return RequestManager.addRequest(dataRequest).then(data => {
    if (data.error) {
      return Promise.reject(data);
    }
    dispatch(
      setRecordingData({
        ...data.response,
        isRecordingData: false,
      }),
    );
  });
};

export const recordingDelete = (config, data) => dispatch => {
  const dataRequest = new RecordingsDeleteTask(config, data);
  return RequestManager.addRequest(dataRequest).then(dataRecording => {
    if (dataRecording.error) {
      return Promise.reject(dataRecording);
    }
    dispatch(setRecordingData({ status: 'ERROR', isRecordingData: false }));
  });
};

export const resetEventCard = () => dispatch => {
  dispatch(setEvent({}));
  dispatch(setContentData({}));
  dispatch(setLinealChannels({}));
  dispatch(setIsLoadingPage(true));
};
